import React, {Component, useEffect, useState} from 'react';
import './styles.scss';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppParagraph from '../../../../components/app-paragraph';
import {strings} from '../../../../util/strings';
import ModalTemplate from '../../../../components/modal';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import AppButton from '../../../../components/app-button';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import {get, post, postWithoutBody} from '../../../../api/api';
import {uriCancelAppointment} from '../../../../api/endpoints';
import moment from 'moment';
import successIconBackground from '../../../../assets/rounded-black-success.svg';

interface AppointmentsCancelPopupProps {
  show: boolean;
  setShowModal(value: any): void;
  labels: typeof strings.pt.appointments;
  labelsPermissions: typeof strings.pt.permissions;
  appointment: any;
  setShowDetailsModal(value: any): void;
  setRefresh(value: any): void;
  globalStyles: any;
  selectedAppointmentProviderId: string;
}

function AppointmentsCancelPopup({
  show,
  setShowModal,
  labels,
  labelsPermissions,
  appointment,
  setShowDetailsModal,
  setRefresh,
  selectedAppointmentProviderId,
  globalStyles,
}: AppointmentsCancelPopupProps) {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isError, setIsError] = useState(false);
  const [disableOptions, setDisableOptions] = useState(false);

  const featureName = 'CancelAppointment';

  const fifteenLeft = moment(appointment?.startTime).subtract(15, 'minutes');
  const appointmentConfirmed =
    (appointment?.status === 'booked' &&
      !moment(new Date()).isAfter(fifteenLeft)) ||
    (appointment?.status === 'Porposed' &&
      !moment(new Date()).isAfter(fifteenLeft));

  const handleCancelAccept = async () => {
    setDisableOptions(true);
    try {
      await postWithoutBody(
        uriCancelAppointment(appointment?.id, selectedAppointmentProviderId),
        false,
        featureName
      );
      setIsConfirmed(true);
    } catch {
      setIsError(true);
    } finally {
      setDisableOptions(false);
    }
  };

  useEffect(() => {
    if (!appointmentConfirmed) {
      setIsError(true);
    }
  }, []);

  const handleCloseCancelled = () => {
    setShowModal(false);
    setShowDetailsModal(false);
    setRefresh(true);
  };

  return (
    appointment && (
      <div className="cancel-modal-container p-0">
        <ModalTemplate
          className="appointment-cancel-container"
          contentClassName="appointment-cancel-content"
          show={show}
          onHide={() => {
            setShowModal(false);
          }}
          cross={true}
          hideFooter={true}
          size="sm">
          {!isConfirmed && !isError && (
            <Column className="errorPopup-column">
              <Row className="health-data-title-row">
                <p
                  style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                  className="p-myProfilePopup">
                  {labels?.appointment_cancel_popup_title}
                </p>
              </Row>
              <Row className="health-data-popup-icon-row">
                <div className="health-data-popup-icon-container">
                  <Icon
                    className="errorPopup-icon"
                    name={Icons.ALERT_PROBLEM}
                    width="18"
                    height="25"
                    color={colors.alertRed}
                  />
                </div>
              </Row>
              <Row className="errorPopup-title-row">
                <p
                  style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
                  className="p-errorPopup">
                  {labels?.appointments_cancel_title}
                </p>
              </Row>
              <Row className="errorPopup-title-row">
                <p
                  style={{...fonts.MM, color: colors.black, marginTop: '-20px'}}
                  className="p-health-data-popup">
                  {labels?.appointments_cancel_text}
                </p>
              </Row>
              <Row className="errorPopup-button">
                <AppButton
                  disabled={disableOptions}
                  className="health-data-button-yes"
                  onClick={() => {
                    handleCancelAccept();
                  }}
                  variant="secondary">
                  {labelsPermissions?.permissions_yes}
                </AppButton>
                <AppButton
                  className="health-data-button-no"
                  onClick={() => {
                    setShowModal(false);
                  }}
                  variant="secondary">
                  {labelsPermissions?.permissions_no}
                </AppButton>
              </Row>
            </Column>
          )}
          {isConfirmed && (
            <div className="modal-error-container-confirmed-cancel">
              {/* <Row
						className="modal-success-title-row">
						{labels?.myProfile_pageTitle}
					</Row> */}

              <Row className="health-data-title-row">
                <p
                  style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                  className="p-myProfilePopup">
                  {labels?.appointment_cancel_popup_title}
                </p>
              </Row>
              <Row className="health-data-popup-icon-row">
                <div className="health-data-popup-icon-container">
                  <img
                    src={successIconBackground}
                    className="cancel-appointment-success"
                  />
                </div>
              </Row>
              <Row
                style={{...fonts.MM, ...fonts.Medium}}
                className="my-profile-modal-success">
                {labels?.appointments_cancel_confirm}
              </Row>
              <Row
                style={{...fonts.MM, ...fonts.Light}}
                className="my-profile-modal-success">
                {labels?.appointments_cancel_confirm_text}
              </Row>
              <Row className="my-profile-submit-button-row">
                <AppButton
                  title="Ok"
                  className="continue-button"
                  variant="secondary"
                  onClick={() => {
                    handleCloseCancelled();
                  }}>
                  Ok
                </AppButton>
              </Row>
            </div>
          )}
          {isError && (
            <div className="modal-error-container">
              <Row className="health-data-title-row">
                <p
                  style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                  className="p-myProfilePopup">
                  {labels?.appointment_cancel_popup_title}
                </p>
              </Row>
              <Row className="my-profile-submit-button-row">
                <Icon
                  name={Icons.ALERT_PROBLEM}
                  width={'40'}
                  height={'40'}
                  color={colors.alertRed}
                  changeViewbox={false}
                />
              </Row>
              <Row className="errorPopup-title-row">
                <p
                  style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
                  className="p-errorPopup">
                  {labelsPermissions?.permissions_readingError}
                </p>
              </Row>
              <Row className="my-profile-submit-button-row">
                <AppButton
                  title="Ok"
                  variant="primary"
                  onClick={() => {
                    setShowModal(false);
                  }}>
                  Ok
                </AppButton>
              </Row>
            </div>
          )}
        </ModalTemplate>
      </div>
    )
  );
}

const mapStateToProps = ({strings, globalStyles}: any) => ({
  labels: strings.value.pt.appointments,
  labelsPermissions: strings.value.pt.permissions,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentsCancelPopup)
);
